<template>
  <div>
    <component-editing-header :component="component"
                              :disable-remove="isSelectedComponent || disableToolbarButtons"
                              :disable-moveto="isSelectedComponent || disableToolbarButtons"
                              :disable-add="!isSelectedComponent || disableToolbarButtons"
                              v-on='$listeners' />
    <div class="pbc-category-main pb-3">
      <h4 class="pbc-category-title">Presets</h4>
      <pbc-button :class="presetClasses(preset)" v-for='preset in availablePhysicsPresets' :key='preset.name' @click='selectPreset(preset)' >
        {{preset.name}}
      </pbc-button>
    </div>


    <div class="pbc-category-main">
      <h4 class="pbc-category-title">Customize</h4>
      <property-form class="py-2"
                    :schema='dataSchema'
                    :model='component'
                    :transform='transform'
                    :partutil='partutil'
                    :transforms-and-source="transformsAndSource"
                    v-on='$listeners' />
    </div>

  </div>
</template>
<script>
import { isEqual, pick, merge } from 'lodash';
import ComponentEditingHeader from '@ui/molecules/ComponentEditingHeader.vue';
import EditingComponentMixin from '@components/editingComponentMixin.js';
const availablePhysicsPresets = [
  {
    name: 'Bouncy Ball',
    shapeType: 'circle',
    bodyType: 'dynamic',
    density: 1,
    friction: 1,
    restitution: 1,
    linearDamping: 0.5,
    angularDamping: 0.5,
    isFixedRotation: false,
    ignoreRotation: false,
    gravityScale: 1,
  },
  {
    name: 'Spaceship',
    shapeType: 'box',
    bodyType: 'dynamic',
    density: 1,
    friction: 0,
    restitution: 0.2,
    linearDamping: 0,
    angularDamping: 1,
    isFixedRotation: false,
    ignoreRotation: false,
    gravityScale: 0,
  },
  {
    name: 'Bullet',
    shapeType: 'box',
    bodyType: 'dynamic',
    density: 1,
    friction: 1,
    restitution: 0,
    linearDamping: 0,
    angularDamping: 1,
    isFixedRotation: true,
    ignoreRotation: true,
    gravityScale: 1,
  },
  {
    name: 'Platform',
    shapeType: 'box',
    bodyType: 'kinematic',
    density: 1,
    friction: 0.2,
    restitution: 0,
    linearDamping: 1,
    angularDamping: 0,
    isFixedRotation: true,
    ignoreRotation: true,
    gravityScale: 1,
  },
]

export default {
  mixins: [EditingComponentMixin],
  data() {
    return {
      quicktweens: [],
      availablePhysicsPresets
    }
  },
  methods: {
    isSelected(preset) {
      const presetKeysOnly = pick(this.component, Object.keys(preset));
      return isEqual(presetKeysOnly, preset);
    },
    presetClasses(preset) {
      const classes = []
      if (this.isSelected(preset)) {
        classes.push('bg-green-500 border border-white');
      } else {
      }
      return classes;
    },
    selectPreset(preset) {
      console.log('select preset', preset);
      this.$set(this, 'component', merge(this.component, preset));
    }
  },
  components:{
    ComponentEditingHeader,
  }
}
</script>
